<template>
  <v-app>
    <v-main>
      <v-container fluid v-if="loading">
        <v-row>
          <v-col class="text-center">
            <v-progress-circular
              :size="150"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid v-else>
        <v-row>
          <v-col>
            <v-form v-if="isMobile">
              <v-select
                v-model="selectPayer"
                :items="payer"
                item-value="id"
                item-text="text"
                label="Плательщик"
                dense
                solo
              />
              <v-select
                v-model="selectStatus"
                :items="status"
                item-value="id"
                item-text="text"
                label="Статус"
                multiple
                dense
                solo
              />
              <v-autocomplete
                v-model="selectContragent"
                :items="contragents"
                item-value="ID"
                item-text="TITLE"
                label="Контрагент"
                dense
                solo
              />
              <v-text-field
                v-model="invoiceNum"
                label="Номер счета"
                dense
                solo
              ></v-text-field>
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateInvoice"
                    label="Дата счета"
                    prepend-icon="mdi-calendar"
                    readonly
                    solo
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateInvoice" range locale="ru-RU">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menuPay = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuDate.save(dateInvoice)"
                  >
                    Сохранить
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="menuPayDate"
                v-model="menuPayDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="payDate"
                    label="Крайний срок оплаты"
                    prepend-icon="mdi-calendar"
                    readonly
                    solo
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="payDate" range locale="ru-RU">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menuPayDate = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuPayDate.save(payDate)"
                  >
                    Сохранить
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-btn
                color="success"
                class="ma-2"
                @click="getReport"
                :disabled="reportLoading"
                >Сформировать
              </v-btn>
              <v-btn color="orange" @click="exportXLS" :disabled="reportLoading"
                >XLS</v-btn
              >
            </v-form>
            <v-form v-else>
              <v-row>
                <v-col cols="2">
                  <v-select
                    v-model="selectPayer"
                    :items="payer"
                    item-value="id"
                    item-text="text"
                    label="Плательщик"
                    dense
                    solo
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="selectStatus"
                    :items="status"
                    item-value="id"
                    item-text="text"
                    label="Статус"
                    multiple
                    dense
                    solo
                  />
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    v-model="selectContragent"
                    :items="contragents"
                    item-value="ID"
                    item-text="TITLE"
                    label="Контрагент"
                    dense
                    solo
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="invoiceNum"
                    label="Номер счета"
                    dense
                    solo
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    ref="menuDate"
                    v-model="menuDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateInvoice"
                        label="Дата счета"
                        prepend-icon="mdi-calendar"
                        readonly
                        solo
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dateInvoice" range locale="ru-RU">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menuPay = false">
                        Отмена
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menuDate.save(dateInvoice)"
                      >
                        Сохранить
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    ref="menuPayDate"
                    v-model="menuPayDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="payDate"
                        label="Крайний срок оплаты"
                        prepend-icon="mdi-calendar"
                        readonly
                        solo
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="payDate" range locale="ru-RU">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menuPayDate = false">
                        Отмена
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menuPayDate.save(payDate)"
                      >
                        Сохранить
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-btn
                color="success"
                class="ma-2"
                @click="getReport"
                :disabled="reportLoading"
                >Сформировать
              </v-btn>
              <v-btn color="orange" @click="exportXLS" :disabled="reportLoading"
                >XLS</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="reportData"
              :items-per-page="5"
              class="elevation-1"
            ></v-data-table>
          </v-col>
        </v-row>
        <v-row class="success">
          <v-col>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ totalRow.payer }}</td>
                  <td>{{ totalRow.invoiceNumber }}</td>
                  <td>{{ totalRow.invoiceDate }}</td>
                  <td>{{ totalRow.needDayPay }}</td>
                  <td>{{ totalRow.baseToPay }}</td>
                  <td>{{ totalRow.contragent }}</td>
                  <td>{{ totalRow.sumPay }}</td>
                  <td>{{ totalRow.invoiceStatus }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";

export default {
  name: "App",

  data: () => ({
    isMobile: false,
    loading: true,
    reportLoading: false,
    menuDate: false,
    dateInvoice: [],
    menuPayDate: false,
    payDate: [],
    invoiceNum: "",
    selectPayer: "",
    selectStatus: "",
    selectContragent: "",
    reportData: [],
    totalRow: {
      baseToPay: "",
      payer: "",
      invoiceStatus: "",
      invoiceNumber: "",
      invoiceDate: "",
      needDayPay: "",
      sumPay: 0,
      sumPayXLS: 0,
      contragent: "Итого:",
    },
    headers: [
      { text: "Плательщик", value: "payer" },
      { text: "Контрагент", value: "contragent" },
      { text: "Крайний срок оплаты", value: "needDayPay" },
      { text: "Сумма", value: "sumPay" },
      { text: "Номер счета", value: "invoiceNumber" },
      { text: "Дата счета", value: "invoiceDate" },
      { text: "Основание для оплаты счета.", value: "baseToPay" },
      { text: "Статус", value: "invoiceStatus" },
    ],
    payer: [
      { id: 141, text: 'ООО "РусАгроМаркет - Холдинг"' },
      { id: 143, text: 'ООО "РусАгроМаркет - Новосибирск"' },
      { id: 145, text: 'ООО "РусАгроСервис-Сибирь"' },
      { id: 147, text: 'ООО "РАМ-Дистрибуция"' },
      { id: 149, text: 'ООО "РАМ-ИТ"' },
      { id: 151, text: 'ООО "РАМ-ТРЭЙД"' },
      { id: 153, text: 'ООО "РАМ-ПЛАТ"' },
      { id: 155, text: 'ООО "РусАгроМаркет-Ростов-на-Дону"' },
    ],
    status: [
      { id: 165, text: "Не согласован и не оплачен" },
      { id: 167, text: "Согласован, но не оплачен" },
      { id: 169, text: "Согласован, оплачен" },
      { id: 171, text: "Отклонен" },
    ],
    contragents: [],
    url: "https://rusagromarket.bitrix24.ru/rest/223/65r4b8xgsehc1t7l/",
  }),
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    getObjectValues(item) {
      return item ? Object.values(item)[0] : "";
    },
    async getCompany() {
      try {
        let i = 0;
        let start = 0;
        while (i === 0) {
          const contragentsData = await axios.get(
            this.url + "crm.company.list",
            {
              params: {
                select: ["ID", "TITLE"],
                start: start,
              },
            }
          );
          for (const contragent of contragentsData.data.result) {
            this.contragents.push(contragent);
          }
          if (contragentsData.data.next) {
            start = contragentsData.data.next;
          } else {
            i = 1;
          }
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },
    getContragent(id) {
      try {
        const contragent = this.contragents.filter((e) => e.ID == id);
        return contragent[0].TITLE;
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      try {
        this.reportLoading = true;
        this.reportData = [];
        this.totalRow = {
          baseToPay: "",
          payer: "",
          invoiceStatus: "",
          invoiceNumber: "",
          invoiceDate: "",
          needDayPay: "",
          sumPay: 0,
          sumPayXLS: 0,
          contragent: "Итого:",
        };
        let start = 0;
        let i = 0;
        while (i === 0) {
          const params = {
            IBLOCK_TYPE_ID: "bitrix_processes",
            IBLOCK_ID: 37,
            FILTER: {},
            start: start,
          };
          if (this.selectPayer) {
            params.FILTER["PROPERTY_183"] = this.selectPayer;
          }
          if (this.selectStatus) {
            params.FILTER["PROPERTY_661"] = this.selectStatus;
          }
          if (this.selectContragent) {
            params.FILTER["PROPERTY_189"] = this.selectContragent;
          }
          if (this.dateInvoice.length > 0) {
            const firstDate = this.dateInvoice[0].split("-");
            const twoDate = this.dateInvoice[1].split("-");
            params.FILTER[">=PROPERTY_185"] =
              firstDate[2] +
              "." +
              firstDate[1] +
              "." +
              firstDate[0] +
              " 00:00:00";
            params.FILTER["<=PROPERTY_185"] =
              twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          }
          if (this.payDate.length > 0) {
            const firstDate = this.payDate[0].split("-");
            const twoDate = this.payDate[1].split("-");
            params.FILTER[">=PROPERTY_665"] =
              firstDate[2] +
              "." +
              firstDate[1] +
              "." +
              firstDate[0] +
              " 00:00:00";
            params.FILTER["<=PROPERTY_665"] =
              twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
          }
          if (this.invoiceNum) {
            params.FILTER["%PROPERTY_203"] = this.invoiceNum;
          }
          console.log({ params });
          const reportItems = await axios.post(
            this.url + "lists.element.get",
            params
          );
          console.log(reportItems.data.result, "result");
          for (const item of reportItems.data.result) {
            this.reportData.push({
              baseToPay: item.DETAIL_TEXT,
              payer: item.PROPERTY_183
                ? this.payer.filter(
                    (e) => e.id == Object.values(item.PROPERTY_183)[0]
                  )[0].text
                : "",
              invoiceStatus: item.PROPERTY_661
                ? this.status.filter(
                    (e) => e.id == Object.values(item.PROPERTY_661)[0]
                  )[0].text
                : "",
              invoiceNumber: this.getObjectValues(item.PROPERTY_203),
              invoiceDate: this.getObjectValues(item.PROPERTY_185),
              needDayPay: this.getObjectValues(item.PROPERTY_665),
              sumPay: new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(Number(this.getObjectValues(item.PROPERTY_199))),
              sumPayXLS: Number(this.getObjectValues(item.PROPERTY_199)),
              contragent: this.getContragent(
                this.getObjectValues(item.PROPERTY_189)
              ),
            });
            this.totalRow.sumPayXLS += Number(
              this.getObjectValues(item.PROPERTY_199)
            );
          }
          if (reportItems.data.next) {
            start = reportItems.data.next;
          } else {
            i = 1;
          }
        }
        this.totalRow.sumPay = new Intl.NumberFormat("ru-RU", {
          minimumFractionDigits: 2,
        }).format(this.totalRow.sumPayXLS);
        this.reportLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async exportXLS() {
      try {
        const outBook = new exeljs.Workbook();
        outBook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = outBook.addWorksheet("Отчет по счетам");
        worksheet.columns = [
          { header: "Плательщик", key: "payer", width: 30 },
          { header: "Контрагент", key: "contragent", width: 30 },
          {
            header: "Крайний срок оплаты",
            key: "needDayPay",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма",
            key: "sumPayXLS",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Всего в оплату на текущую неделю Итого",
            key: "sumPayXLS1",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Остаток оплат на текущую неделю Итого",
            key: "sumPayXLS2",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "В оплату",
            key: "sumPayXLS3",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          { header: "Номер счета", key: "invoiceNumber", width: 20 },
          {
            header: "Дата счета",
            key: "invoiceDate",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          { header: "Основание для оплаты счета", key: "baseToPay", width: 30 },
          { header: "Статус", key: "invoiceStatus", width: 20 },
        ];
        for (const item of this.reportData) {
          const objRow = worksheet.addRow(item);
          objRow.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        const totalRow = worksheet.addRow(this.totalRow);
        totalRow.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const buffer = await outBook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "invoices_report.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;

    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  mounted() {
    this.getCompany();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
